import { render } from "./OrderTable.vue?vue&type=template&id=0f099b14&scoped=true"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=0f099b14&scoped=true&lang=css&external"
import "./OrderTable.vue?vue&type=style&index=1&id=0f099b14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f099b14"]])

export default __exports__